import styled from "@emotion/styled";
import { Link } from "react-router-dom";
import FlexColumn from "shared/components/Layout/components/FlexColumn";
import theme from "shared/theme";
import { COLOR_GREY_2, COLOR_GREY_5, COLOR_WHITE } from "shared/theme/colors";
import { text } from "shared/theme/mixins";

export const StyledSideBarContainer = styled(FlexColumn)`
  width: 250px;
  padding: 16px;
  border-right: 1px solid ${COLOR_GREY_5};
`;

export const StyledSideBarLink = styled(Link, {
  shouldForwardProp: (prop) => prop !== "isActive",
})<{ isActive: boolean }>`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
  gap: 12px;
  ${text(theme.typography.bodyMRegular)};
  text-decoration: none;
  background: ${({ isActive }) => (isActive ? COLOR_GREY_2 : COLOR_WHITE)};
  border-radius: 6px;

  &:hover {
    background-color: ${COLOR_GREY_2};
  }
`;
